// External dependencies

import jQuery from 'jquery';

jQuery(document).ready(function($) {
    var isProcessing = false;
    
    $('#view-more-comments').on('click', function() {
        if (isProcessing) return;

        var post_id = $(this).data('post-id');
        var currentPage = parseInt($(this).data('current-page'));
        var maxPages = parseInt($(this).data('max-pages'));

        if (currentPage >= maxPages) {
            $(this).hide();
            return;
        }

        isProcessing = true;

        $.ajax({
            url: RETO_AjaxCommentParams.ajaxurl,
            type: 'POST',
            data: {
                action: 'load_more_comments',
                post_id: post_id,
                paged: currentPage + 1 
            },
            beforeSend: function() {
                $('#view-more-comments').attr('disabled', 'disabled');
                $('#view-more-comments').text('Loading...');
            },
            success: function(response) {
                $('ol.comment-list').append(response);

                $('#view-more-comments').data('current-page', currentPage + 1);

                // Hide the button if the current page is the last one
                if ((currentPage + 1) >= maxPages) {
                    $('#view-more-comments').hide();
                }

                $('#view-more-comments').removeAttr('disabled');
                $('#view-more-comments').text('View More Comments');
            },
            complete: function() {
                isProcessing = false;
            },
            error: function() {
                alert("Failed to load comments. Please try again.");
                $('#view-more-comments').removeAttr('disabled');
                $('#view-more-comments').text('View More Comments');
            }
        });
    });
});